export default "__VITE_PUBLIC_ASSET__e5fe9a62__"